import ShowDeleteModal from "./show_delete_modal";
import { ShowUpdateActionManager } from "../../action_managers/shows";
import { hideModal } from "../../actions/modal";
import { connect } from "react-redux";
import { withRouter } from "react-router";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    isLoading: state.shows.isLoading || state.showForm.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => {
      dispatch(hideModal());
    },
    deleteShow: (showUUID, user) => {
      return dispatch(
        new ShowUpdateActionManager({
          // soft delete with isVisible
          show: { uuid: showUUID, isVisible: false },
          user: user,
          successMessage: "Show Deleted",
        }).run()
      );
    },
  };
}

const ShowDeleteModalWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShowDeleteModal)
);

export default ShowDeleteModalWrapper;
